const $$splitComponentImporter = () => import('/home/runner/work/zngly-corporate/zngly-corporate/wp-content/themes/zngly-corporate/frontend/src/routes/dash/settings/customisation/qr-code/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/dash/settings/customisation/qr-code/')({
  component: lazyRouteComponent($$splitComponentImporter, 'component', () => Route.ssr)
});